import { apiClient } from '@/core/api/client';
import type {
  AffaireActiveStatusResponse,
  SetInactiveTemporaryRequest,
  SetInactivePausedRequest,
} from '../types/tracker.types';

/**
 * Get affaire active/inactive status
 */
export const getAffaireActiveStatus = async (
  affaireId: number
): Promise<AffaireActiveStatusResponse> => {
  return apiClient.get<AffaireActiveStatusResponse>(
    `/api/admin/affaire-active/${affaireId}`
  );
};

/**
 * Set affaire as temporarily inactive until a specific date
 */
export const setAffaireInactiveTemporary = async (
  affaireId: number,
  request: SetInactiveTemporaryRequest
): Promise<AffaireActiveStatusResponse> => {
  return apiClient.post<AffaireActiveStatusResponse>(
    `/api/admin/affaire-active/${affaireId}/freeze-temporary`,
    request
  );
};

/**
 * Pause affaire until next activity occurs
 */
export const setAffairePausedUntilActivity = async (
  affaireId: number,
  request: SetInactivePausedRequest
): Promise<AffaireActiveStatusResponse> => {
  return apiClient.post<AffaireActiveStatusResponse>(
    `/api/admin/affaire-active/${affaireId}/pause-until-activity`,
    request
  );
};

/**
 * Clear manual inactive status and re-evaluate based on automatic rules
 */
export const clearAffaireManualInactive = async (
  affaireId: number
): Promise<AffaireActiveStatusResponse> => {
  return apiClient.post<AffaireActiveStatusResponse>(
    `/api/admin/affaire-active/${affaireId}/clear-manual-inactive`
  );
};

/**
 * Force refresh affaire active status
 */
export const refreshAffaireActiveStatus = async (
  affaireId: number
): Promise<AffaireActiveStatusResponse> => {
  return apiClient.post<AffaireActiveStatusResponse>(
    `/api/admin/affaire-active/${affaireId}/refresh`
  );
};
